import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import ProductsOrdered from "../../../features/orders/ProductsOrdered";
import { useLazyGetReturnExchangeByIdQuery } from "../../../services/returnExchange";
import { ImageModal } from "../../../components";

const ReturnExchangeDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { id } = useParams();
  const [getOrderById] = useLazyGetReturnExchangeByIdQuery();
  const [orderData, setOrderData] = useState<any>("");

  const fetchDataById = async () => {
    try {
      const response = await getOrderById({ id, type: state }).unwrap();
      if (response.status === 200) {
        setOrderData(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDataById();
  }, []);

  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Return & Exchange Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-return-exchange");
            }}
          >
            Back
          </Button>
        </div>
        <Card className="cards">
          <CardContent sx={{ p: 2 }}>
            {orderData && (
              <Box>
                <Typography variant="body1">
                  <strong>Name:</strong> {orderData.name}
                </Typography>
                <Typography variant="body1">
                  <strong>Phone:</strong> {orderData.phoneNo}
                </Typography>
                <Typography variant="body1">
                  <strong>Address:</strong> {orderData.address},{" "}
                  {orderData.city}, {orderData.pinCode}
                </Typography>
                <Typography variant="body1">
                  <strong>Order Status:</strong>{" "}
                  {orderData.orderStatus === 1
                    ? "Order Placed"
                    : orderData?.orderStatus === 2
                      ? "In-Progress"
                      : orderData?.orderStatus === 3
                        ? "shipping"
                        : orderData?.orderStatus === 4
                          ? "Delivered"
                          : null}
                </Typography>
                <Typography variant="body1">
                  <strong>Total Cost:</strong> AED {orderData.totalCostPay}
                </Typography>
              </Box>
            )}
            <Grid container spacing={2} sx={{ mt: 2 }}>
              {orderData?.exchange_product_list?.map(
                (product: any, index: number) => (
                  <Grid key={index} item xs={12} sm={6} md={4} lg={4}>
                    <Box
                      sx={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: 2,
                        textAlign: "center",
                      }}
                    >
                      {product?.images?.length > 0 && (
                        <img
                          src={product.images[0]}
                          alt={product.productName}
                          style={{
                            width: "100%",
                            height: "150px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            marginBottom: "1rem",
                          }}
                          // onClick={() => handleOpenModal(product.images[0])}
                        />
                      )}
                      <Typography variant="h6" sx={{ mb: 1 }}>
                        {product.productName}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Min Quantity:</strong> {product.minQuantity}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Price per Unit:</strong> AED{" "}
                        {product.pricePerUnit}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Ordered Quantity:</strong> {product.buyQuantity}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Total Price:</strong> AED {product.buyPrice}
                      </Typography>
                    </Box>
                  </Grid>
                )
              )}
            </Grid>
          </CardContent>
          {/* <ImageModal open={open} handleClose={handleClose} image={selectedImage} /> */}
        </Card>
      </div>
    </div>
  );
};

export default ReturnExchangeDetails;
